import Vue from 'vue';
import Vuex from 'vuex';

import { alert } from './alert.module';
import { account } from './account.module';
import { users } from './users.module';
import { events } from './event.module';
import { activityEvents } from './activity.module';
import  { messages } from './messages.module';

Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
    	alert,
        account,
        users,
        events,
        activityEvents,
        messages
    }
});
